import * as PIXI from 'pixi.js';
import { BubbleViewHandler } from '../BubbleViewHandler';
import { BubbleType, BubbleColor } from '../../../bubbles/types';
import { BubbleDestroyReason } from 'js/bubbleCore/events';
import { IEvent, EventType } from 'js/bubbleCore/events';
import { Layer } from 'js/bubbleCore/view/BoardAnimationLayer';

const colorAssetMap: { [key in BubbleColor]: string } = {
  [BubbleColor.A]: '0_bubble_blue',
  [BubbleColor.B]: '0_bubble_green',
  [BubbleColor.C]: '0_bubble_pink',
  [BubbleColor.D]: '0_bubble_red',
  [BubbleColor.E]: '0_bubble_turquoise',
  [BubbleColor.F]: '0_bubble_yellow',
  [BubbleColor.NONE]: 'warning_bubble_2',
};

const animationLength = 5;

export class RegularViewHandler extends BubbleViewHandler<BubbleType.Regular> {
  public sprite: PIXI.Sprite | null = null;

  public initView(): void {
    this.sprite = new PIXI.Sprite(PIXI.Texture.from(colorAssetMap[this.model.core.color]));
    this.sprite.anchor.set(0.5);
    this.view.addChild(this.sprite);
  }

  public animatePopOut(): void {
    const position = this.view.toGlobal(new PIXI.Point());
    const shockwave = this.view.animationLayer.createShockwave();
    const burst = this.view.animationLayer.createBubbleBurst(this.model.core.color);
    burst.root.alpha = 0.5;
    this.view.animationLayer.addToLayer(burst.root, position, Layer.AboveGrid);
    this.view.animationLayer.addToLayer(shockwave.root, position, Layer.AboveGrid);
  }

  public async animateKill(event: IEvent): Promise<void> {
    if (
      event.type === EventType.BubbleDestroyed &&
      (event as IEvent<EventType.BubbleDestroyed>).data.reason === BubbleDestroyReason.TopCollision
    ) {
      return;
    }

    if (this.sprite) {
      this.sprite.destroy();
      this.sprite = null;
    }

    const splash = this.view.animationLayer.createSplashAnimation(this.model.core.color)
    const burst = this.view.animationLayer.createBubbleBurst(this.model.core.color);
    this.view.addChild(splash.root, burst.root);

    await splash.onCompleteAsync;
    await burst.onCompleteAsync;
  }

  public cleanup(): void {
    if (this.sprite) {
      this.sprite.destroy();
      this.sprite = null;
    }
  }

  private getAsset(): string {
    return colorAssetMap[this.model.core.color]
  }

  private getKillTextures(): PIXI.Texture[] {
    const result: PIXI.Texture[] = [];
    const asset = this.getAsset();
    for (let i = 1; i <= animationLength; i++) {
      result.push(PIXI.Texture.from(`${asset}_${i}`));
    }
    return result;
  }
}